import type { AnalysisBaseSchema } from '@libs/data-access/entities'

export const getStatistics = (
  real: boolean,
  statistics: AnalysisBaseSchema
) => {
  if (real) {
    return {
      payroll_in_euro: statistics.actual_payroll_in_euro,
      payroll_ratio: statistics.actual_payroll_ratio,
      productivity_in_euro_per_hour:
        statistics.actual_productivity_in_euro_per_hour,
      sales_in_euro: statistics.actual_sales_in_euro,
      worked_in_minutes: statistics.actual_worked_in_minutes,
      overtime_duration_in_minutes:
        statistics.actual_overtime_duration_in_minutes,
      overtime_cost_in_euro: statistics.actual_overtime_cost_in_euro
    }
  }

  return {
    payroll_in_euro: statistics.budget_payroll_in_euro,
    payroll_ratio: statistics.budget_payroll_ratio,
    productivity_in_euro_per_hour:
      statistics.budget_productivity_in_euro_per_hour,
    sales_in_euro: statistics.budget_sales_in_euro,
    worked_in_minutes: statistics.budget_worked_in_minutes,
    overtime_duration_in_minutes:
      statistics.budget_overtime_duration_in_minutes,
    overtime_cost_in_euro: statistics.budget_overtime_cost_in_euro
  }
}
